export enum MapTileStyles {
  LightDark = 'lightDark',
  Streets = 'streets',
  Satellite = 'satellite',
}
